<template>
<section class="sc-o27kl3-0 gsZmuC product-slider-section">
  <div class="d-flex justify-content-between align-items-center">
      <h3 class="mb-3 h3 pr-3"> پرفروش ترین ها</h3>
      <h5 class="text-primary pl-3" role="button" @click="goWoleBest">همه <i class="fa fa-chevron-left small"></i></h5>
  </div>
  <div>
    <div class="sc-d8w7bo-1 jpdybm">
      <div direction="row" class="sc-1r3hge1-0 heMFVq scroll-example ">
          <product-vue :list="props.items"></product-vue>
       </div>
    </div>
  </div>
</section>
  

</template>

<script setup>
import productVue from '@/components/section/item/product.vue';
import { defineProps } from 'vue';
let props = defineProps(['items'])
import {useRouter} from 'vue-router';
let router = useRouter()
function goWoleBest(){
  router.push({name:'bestWoleBtn'})
}

</script>

<style scoped>
i{
  vertical-align: bottom;
}
</style>